import { BUSINESS_TYPE } from "@faire/retailer-visitor-shared/consts/BUSINESS_TYPE";
import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { IRetailer } from "@faire/web-api--source/indigofair/data/IRetailer";
export var useRetailerType = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var retailer = useRetailer().retailer;
    var _useRetailerStore = useRetailerStore([
        "isNewUser",
        "isGuestRetailer",
        "isOnlineOnlyRetailer",
        "isNonBrickAndMortarRetailer"
    ]), isNewUserControl = _useRetailerStore.isNewUser, isGuestRetailerControl = _useRetailerStore.isGuestRetailer, isOnlineOnlyRetailerControl = _useRetailerStore.isOnlineOnlyRetailer, isNonBrickAndMortarRetailerControl = _useRetailerStore.isNonBrickAndMortarRetailer;
    var isNewUser = !!retailer && !retailer.first_order_at;
    var _retailer_is_guest;
    var isGuestRetailer = (_retailer_is_guest = retailer === null || retailer === void 0 ? void 0 : retailer.is_guest) !== null && _retailer_is_guest !== void 0 ? _retailer_is_guest : false;
    var isOnlineOnlyRetailer = !!(retailer === null || retailer === void 0 ? void 0 : retailer.online_only) || (retailer === null || retailer === void 0 ? void 0 : retailer.business_category) === IRetailer.BusinessCategory.ONLINE_ONLY;
    var isNonBrickAndMortarRetailer = (retailer === null || retailer === void 0 ? void 0 : retailer.business_type) !== BUSINESS_TYPE.BRICK_AND_MORTAR_SHOP;
    if (shouldUseHooksMigration) {
        return {
            isNewUser: isNewUser,
            isGuestRetailer: isGuestRetailer,
            isOnlineOnlyRetailer: isOnlineOnlyRetailer,
            isNonBrickAndMortarRetailer: isNonBrickAndMortarRetailer
        };
    }
    return {
        isNewUser: isNewUserControl,
        isGuestRetailer: isGuestRetailerControl,
        isOnlineOnlyRetailer: isOnlineOnlyRetailerControl,
        isNonBrickAndMortarRetailer: isNonBrickAndMortarRetailerControl
    };
};
